<div class="grouped-result-item">
  <div class="grouped-result-header">
    <i *ngIf="!isStateTogglingBetweenExpandCollapse"
       class="fa fa-light grouped-result-chevron"
       [ngClass]="groupItem.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
       [tooltip]="groupItem.expanded ? ('REPORTS.collapse' | translate) : ('REPORTS.expand' | translate)"
       (click)="toggleGroupItem(groupItem)">
    </i>
    <i *ngIf="isStateTogglingBetweenExpandCollapse"
       class="fa fa-light fa-spinner fa-spin grouped-result-chevron">
    </i>
    <div class="grouped-result-header-content">
      <span class="grouped-label-title">
        <strong>{{ groupItem.columnName }}</strong>:
        <span class="grouped-label-value">
          <ng-container *ngIf="isNumericValue(groupItem.value); else plainValue">{{ getLocalizedNumber(+groupItem.value) }}</ng-container>
          <ng-template #plainValue>{{ getDisplayValue(groupItem.value) }}</ng-template>
        </span>
      </span>
      <span class="grouped-label-count">{{ groupItem.count }} {{ 'REPORTS.result_s' | translate }}</span>
    </div>
  </div>
  <div class="grouped-result-rows" *ngIf="groupItem.expanded">
    <gp-hot-table
      #expandedHotTable="gpHotTable"
      class="hot-table grouped-rows-hot-table"
      [colHeaders]="previewData.headers"
      [nestedHeaders]="previewData.nestedHeaders"
      [columns]="getColumnsWithAction(groupItem)"
      [options]="optionsWithSort"
      [data]="groupItem.rows"
      [tooltipHeaders]="previewData.tooltipHeaders">
    </gp-hot-table>
    <gp-report-summary-row
      [columns]="getColumnsWithAction(groupItem)"
      [data]="groupItem.rows"
      [hotInstance]="expandedHotTable?.table">
    </gp-report-summary-row>
  </div>
  <div class="grouped-result-collapsed-summary" *ngIf="!groupItem.expanded && hasNumericColumn">
    <table class="table collapsed-summary-table">
      <caption>Table for collapse mode</caption>
      <thead>
        <tr>
          <th *ngFor="let col of collapsedColumns; let i = index">
            <span class="th-inner">{{ previewData.headers?.[i] ?? '' }}</span>
          </th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <td *ngFor="let col of collapsedColumns; let last = last">
            <span *ngIf="col.type === 'numeric'" class="summary-value">
              {{ getColumnSum(groupItem.rows, col.data) }}
            </span>
            <span *ngIf="last && col.type !== 'numeric'" class="summary-label">
              {{ 'COMMON.total' | translate }}
            </span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

